<template>
<v-container class="mt-3">
  <div>
    <v-data-table
      :headers="headers"
      :items="bases"
      :page.sync="page"
      :items-per-page="5"
      @page-count="pageCount = $event"
      :search="search"
      class="elevation-1 pa-3">

      <template v-slot:top>
        <v-toolbar flat color="white">

          <v-toolbar-title>Bases</v-toolbar-title>

          <v-spacer></v-spacer>
          <div v-if="errorDelete" class="errorText">{{errorDelete}}</div>
          <v-spacer></v-spacer>
          <!--Dialog para adicionar base -->
          <v-dialog
            v-model="dialog"
            max-width="700px">

            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on">
                <v-icon left>add</v-icon>Adicionar Novo
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-form ref="formBase" @submit.prevent="saveNewBase()"   v-model="valid" lazy-validation>
                  <v-container>

                    <v-row>
                      <v-col cols="12" xs="12">
                        <v-text-field
                          outlined
                          v-model="baseFromDialog.name"
                          required
                          :rules="baseRules"
                          label="Nome">
                        </v-text-field>
                      </v-col>

                      <v-col cols="8" xs="8">
                        <v-text-field
                          outlined
                          v-model="baseFromDialog.address.street"
                          required
                          :rules="baseRules"
                          label="Rua/Avenida:">
                        </v-text-field>
                      </v-col>

                      <v-col cols="4" xs="4">
                        <v-text-field
                          required
                          :rules="baseRules"
                          outlined
                          v-model="baseFromDialog.address.number"
                          label="Número:">
                        </v-text-field>
                      </v-col>

                      <v-col cols="6" xs="6">
                        <v-text-field
                          required
                          :rules="baseRules"
                          outlined
                          v-model="baseFromDialog.address.neighborhood"
                          label="Bairro:">
                        </v-text-field>
                      </v-col>

                      <v-col cols="3" xs="3">
                        <v-text-field
                          required
                          :rules="baseRules"
                          outlined
                          v-model="baseFromDialog.address.city"
                          label="Cidade:">
                        </v-text-field>
                      </v-col>

                      <v-col cols="3" xs="3">
                        <v-text-field
                          required
                          :rules="baseRules"
                          outlined
                          v-model="baseFromDialog.address.state"
                          label="Estado:">
                        </v-text-field>
                      </v-col>

                      <v-col cols="3" xs="3">
                        <v-text-field
                          required
                          :rules="baseRules"
                          outlined
                          v-mask="mask.cep"
                          v-model="baseFromDialog.address.zipcode"
                          label="CEP:">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <!-- ações de dialog -->
              <v-card-actions>

                <v-btn
                  color="primary"
                  dark
                  @click="close">
                  Cancelar
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                  color="primary"
                  dark
                  @click="saveNewBase">
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-spacer></v-spacer>

        <v-text-field
          class="mx-4 mb-5"
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details>
        </v-text-field>
      </template>

      <template v-slot:[`item.actions`]="{ item }">

        <v-icon class="mr-2" @click="openEdit(item)">mdi-pencil</v-icon>

        <v-tooltip v-if="item.status === 1" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="error" @click="disableItem(item)">home</v-icon>
          </template>
          <span>Desabilitar base</span>
        </v-tooltip>
        <v-tooltip v-else top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="success" v-bind="attrs" v-on="on" @click="enableItem(item)">home</v-icon>
          </template>
          <span>Habilitar base</span>
        </v-tooltip>

      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          :class="getTextColor(item.status)"
          label
          :color="getColor(item.status)"
          dark>
          {{ item.status && item.status === 1 ? "Ativo": item.status === 0 ? "Desativado" : "Pendente" }}
        </v-chip>
      </template>

      <template v-slot:[`item.address`]="{ item }">
        {{ makeAddress(item.address) }}
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        {{ formartDate(item.created_at) }}
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount">
      </v-pagination>
    </div>

    <v-dialog
      v-model="dialogEdit"
      max-width="700px">
      <v-card>

        <v-card-title>
          <span class="headline">Editando Base</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="formBaseEdit" @submit.prevent="saveEdition()">
              <v-container>

                <v-row>
                  <v-col cols="12" xs="12">
                    <v-text-field
                      outlined
                      v-model="baseFromDialog.name"
                      required
                      :rules="baseRules"
                      label="Nome">
                    </v-text-field>
                  </v-col>

                  <v-col cols="8" xs="8">
                    <v-text-field
                      outlined
                      v-model="baseFromDialog.address.street"
                      required
                      :rules="baseRules"
                      label="Rua/Avenida:">
                    </v-text-field>
                  </v-col>

                  <v-col cols="4" xs="4">
                    <v-text-field
                      required
                      :rules="baseRules"
                      outlined
                      type="number"
                      v-model="baseFromDialog.address.number"
                      label="Número:">
                    </v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6">
                    <v-text-field
                      required
                      :rules="baseRules"
                      outlined
                      v-model="baseFromDialog.address.neighborhood"
                      label="Bairro:">
                    </v-text-field>
                  </v-col>

                  <v-col cols="3" xs="3">
                    <v-text-field
                      required
                      :rules="baseRules"
                      outlined
                      v-model="baseFromDialog.address.city"
                      label="Cidade:">
                    </v-text-field>
                  </v-col>

                  <v-col cols="3" xs="3">
                    <v-text-field
                      required
                      :rules="baseRules"
                      outlined
                      v-model="baseFromDialog.address.state"
                      label="Estado:">
                    </v-text-field>
                  </v-col>

                  <v-col cols="3" xs="3">
                    <v-text-field
                      required
                      :rules="baseRules"
                      outlined
                      v-mask="mask.cep"
                      v-model="baseFromDialog.address.zipcode"
                      label="CEP:">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>
        <!-- ações de dialog -->

        <v-card-actions>
          <v-row class="ma-0 pa-0">
            <v-col cols="11" v-if="textError">
              <span class="errorText">{{textError}}</span>
            </v-col>
            <v-col cols="6" justify="center" align="start">
              <v-btn
                color="primary"
                dark
                @click="close">
                Cancelar
              </v-btn>
            </v-col>

            <v-col cols="6" justify="center" align="end">
              <v-btn
                color="primary"
                dark
                @click="saveEdition">
                Salvar Edições
              </v-btn>
            </v-col>
          </v-row>


        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</v-container>
</template>

<script>
var moment = require("moment");
import { mask } from 'vue-the-mask';
export default {
  directives:{ mask },
  data: () => ({
    search: '',
    valid: true,
    dialog: false,
    page: 1,
    pageCount: 0,
    textError: undefined,
    headers: [
      { text: "Nome", value: "name", align: "start", sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: "Lozalização", value: "address", sortable: false },
      { text: "Data de Registro", value: "created_at", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    baseRules: [ v=> !!v || 'Campo precisa ser preenchido!', v=> (!!v && v.length > 1 )  || 'Campo precisa ter mais de um caracter!'  ],
    editedIndex: -1,
    baseFromDialog: {
      name: '',
      address: {
        zipcode: '',
        state: '',
        city: '',
        neighborhood: '',
        street: '',
        number: '',
        latitude: '',
        longitude: '',
      },
    },
    mask: { cep: "#####-###"
    },
    dialogEdit: false,
    errorDelete: undefined,
  }),

  created (){

    this.initialize();
  },

  computed: {

    bases (){
      let bases = this.$store.getters.bases;
      return bases;
    },

    formTitle (){
      return this.editedIndex === -1 ? "Nova Base" : "Editar Base";
    },
  },
  watch: {

    dialog (val){
      val || this.close();
    },
  },

  methods: {

    getDefaultBase(){
      return {
        name:'',
        address:{
          zipcode: '',
          state: 'AM',
          city: 'Manaus',
          neighborhood: '',
          street: '',
          number: '',
          latitude: '',
          longitude: ''
        }
      };
    },

    makeAddress (address){
      let faddress = "";
      if(address){
        faddress = address.street + ", "+ address.number+ ", "+ address.neighborhood+ ", " + address.zipcode;
      }
      return faddress;
    },

    formartDate (created_at){
      let fdate = moment(new Date(created_at)).format("D/M/Y HH:mm");
      return fdate;
    },

    async initialize (){
      this.baseFromDialog = this.getDefaultBase();
      this.errorSave = undefined;
      await this.$store.dispatch("downloadBases");
    },

    openEdit(item){
      this.baseFromDialog = {...item};
      this.dialogEdit = true;
    },

    getColor (status) {

      if (status === 1) return 'green lighten-4'
      else if (status === 0) return 'red lighten-4'
      else return 'amber lighten-4'
    },

    getTextColor (status) {

      if (status === 1) return 'green--text'
      else if (status === 0) return 'red--text'
      else return 'orange--text'
    },
    async disableItem (item) {
      console.log('Verificar se API foi atualizado',item)
      item.status = 0;
      let novo = {
          status: item.status,
          id: item.id
      };
      let res = await this.$store.dispatch('editBase',novo);
    },

    async enableItem (item) {
      console.log('Verificar se API foi atualizado',item)
      item.status = 1;
      let novo = {
          status: item.status,
          id: item.id
      };
      let res = await this.$store.dispatch('editBase',novo);
    },

    async saveNewBase (){
      this.errorSave = undefined;
      if(this.$refs.formBase.validate()){
        let saved = await this.$store.dispatch("addBase", this.baseFromDialog)
            .then( response=> {
              return response.status;
            });
        if(saved){
          this.initialize();
        }
        this.close();
      }
    },

    async saveEdition (){
      let ok = this.$refs.formBaseEdit.validate();
      this.textError = undefined;
      if (ok){
        let editedBase =  {...this.baseFromDialog};
        delete editedBase.updated_at;
        delete editedBase.index;
        delete editedBase.created_at;
        delete editedBase.address_id;
        let edited = await this.$store.dispatch("editBase", editedBase)
          .then( response=> {
            if (response.status){
              this.$refs.formBaseEdit.resetValidation()
              this.$refs.formBaseEdit.reset();
              return true;
            }
            else{
              console.log(JSON.stringify( response, null, ' '));
              if (response.response) {
                this.setErrorSave(response.response.data.message);
              }
              else if (response.request) {
                this.setErrorSave(response.request.response.data.message);
              }
              else {
                this.setErrorSave(response.message);
              }
              return false;
            }
          })
          .catch( error => {
            this.setErrorSave(error.message);
            return undefined;
          });
        if (edited){
          this.initialize();
          this.close();
        }
      }
    },

    setErrorSave (errorMsg) {
      this.textError = errorMsg;
    },

    setErrorDelete (errorMsg) {
      this.errorDelete = errorMsg;
      setTimeout(() => {
        this.errorDelete = undefined;
      }, 5000);
    },

    async deleteItem (item){
      if (confirm("Are you sure you want to delete this Base ?")) {
        let deleted = await this.$store.dispatch("removeBase", item.id)
          .then( response=> {
            if (response.status) {
              return true;
            }
            else{
              console.log(JSON.stringify( response, null, ' '));
              if (response.response) {
                let msgError = response.response.data.message;
                if (msgError.includes('violates foreign key constraint')){
                  this.setErrorDelete('Ambulância associada, base não pode ser deleteda.');
                }
                else {
                  this.setErrorDelete(msgError);
                }
              }
              else if (response.request) {
                this.setErrorDelete(response.request.response.data.message);
              }
              else {
                this.setErrorDelete(response.message);
              }
              return false;
            }
          });
        if (deleted){
          this.initialize();
        }
      }
    },

    close (){
      this.dialog = false;
      this.dialogEdit = false;
      setTimeout(() => {
        this.baseFromDialog = Object.assign({}, this.getDefaultBase());
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>

<style scoped>
.errorText{
  align-items: center;
  text-align: center;
  color: crimson;
  background: khaki;
}
</style>
